module.exports = __webpack_public_path__ + "static/media/farmacia.7039f4b6.svg";